import axiosV2, { apiPost } from '../core/http/axios_api_v2';

export default {

    //type is optional - 'whatsapp' / 'email' narrows the list to one channel (the header
    //whatsapp box), anything else brings every conversation as before
    getLatest(limit,customerId,type) {
        if (!limit)
            limit = 5;
        if (!customerId)
            customerId = 0;
        let typeParam = type ? `&type=${type}` : '';
        return axiosV2(`planup-multi-messages?limit=${limit}&customerId=${customerId}${typeParam}`).then(response => response.data);
    },



    loadConversation(msgGroup) {

        if (!msgGroup)
            return new Promise(x => []);

        return axiosV2(`planup-multi-messages/loadConversation/${msgGroup}`).then(response => response.data);

    },


    
}